function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.665 9.5c-.367 0-.669-.299-.631-.664a6.5 6.5 0 0 1 1.897-3.959c.26-.258.682-.21.912.076.23.286.181.702-.073.967a5.17 5.17 0 0 0-1.397 2.917c-.047.364-.34.663-.708.663z",
  fill: "#E4922F"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.665 9.5c.367 0 .66-.299.708-.663A5.17 5.17 0 0 1 5.77 5.92c.254-.265.304-.68.073-.967l-.415-.517h-.003a6.5 6.5 0 0 0-2.391 4.4c-.038.365.264.664.631.664z",
  fill: "currentColor"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.335 9.5c.367 0 .668-.299.631-.664a6.498 6.498 0 0 0-1.81-3.87c-.256-.264-.678-.224-.913.057-.236.282-.195.699.054.969a5.17 5.17 0 0 1 1.33 2.845c.047.364.34.663.708.663z",
  fill: "#E4922F"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.335 9.5c-.367 0-.66-.299-.708-.663a5.17 5.17 0 0 0-1.33-2.845c-.249-.27-.29-.687-.054-.969l.425-.508h.003a6.499 6.499 0 0 1 2.295 4.321c.037.365-.264.664-.631.664z",
  fill: "currentColor"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.276 4.368c.175-.323.056-.73-.284-.871a6.5 6.5 0 0 0-4.974-.004c-.34.14-.46.547-.286.87.175.323.577.44.92.309a5.17 5.17 0 0 1 3.704.003c.343.132.745.016.92-.307z",
  fill: "#E4922F"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.96 4.95a5.17 5.17 0 0 0-4.914-.004l-.629-1.168a6.5 6.5 0 0 1 6.173.003c.001.001.002.003.001.004l-.63 1.166z",
  fill: "currentColor"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.964 11.595c-.152.15-.424.611-.522.813a1.92 1.92 0 0 0 3.46 1.662c.096-.203.277-.687.3-.898l1.014-6.275-4.252 4.698zm1.77 1.983a.655.655 0 0 1-.996-.847.654.654 0 0 1 .996.847z",
  fill: "currentColor"
});

const SvgThreshold = props => React.createElement("svg", _extends({
  width: 19,
  height: 19,
  fill: "none"
}, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);

export default SvgThreshold;